import React, { FC, PropsWithChildren } from "react";
import { Link } from "../link";
// import Image from "next/image";
import type { PostPreview } from "@/types";
import type { TranslationItem } from "@/translations";
import { Image } from "../image";

interface Props {
  searchValue: string;
  results: PostPreview[] | null;
  resultsCount: number;
  translations: {
    filtersTitle: string;
    title: string;
    cta: TranslationItem;
    empty: string;
  };
}

export const SearchResults: FC<PropsWithChildren<Props>> = ({
  searchValue,
  results,
  resultsCount,
  translations,
}) => {
  const [selectedFilter, setSelectedFilter] = React.useState("");
  const [filteredSearchResults, setFilteredSearchResults] = React.useState<
    PostPreview[]
  >([]);

  const filterButtons = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Blog",
      value: "blogs",
    },
    {
      label: "News",
      value: "news",
    },
    {
      label: "Insights",
      value: "insights",
    },
  ];

  const formatDate = (date: string) => {
    const dateObj = new Date(date);
    const month = dateObj.toLocaleString("default", { month: "long" });
    const day = dateObj.getDate();

    return `${month} ${day}`;
  };

  React.useEffect(() => {
    if (selectedFilter && results) {
      setFilteredSearchResults(
        results.filter((result) => result.group === selectedFilter)
      );
    } else if (results) {
      setFilteredSearchResults(results);
    }
  }, [selectedFilter, results]);

  return (
    <div className="searchResults">
      {(results?.length || 0) > 0 && (
        <>
          <div className="searchResults--filtersTitle">
            {translations.filtersTitle}
          </div>
          <div className="searchResults--filters">
            {filterButtons.map((filter, index) => {
              return (
                <button
                  key={index}
                  className={`searchResults--filter ${
                    selectedFilter === filter.value
                      ? "searchResults--filter_active"
                      : ""
                  }`}
                  onClick={() => {
                    setSelectedFilter(filter.value);
                  }}
                >
                  {filter.label}
                </button>
              );
            })}
          </div>
        </>
      )}
      {(results?.length || 0) > 0 ? (
        <>
          <div className="searchResults--title">
            {translations.title} ‘{searchValue}’
          </div>
          <div className="searchResults--results">
            {filteredSearchResults.slice(0, 3).map((result, index) => {
              return (
                <Link
                  href={`/resources/${result.group}/${result.slug}`}
                  noStyle
                  key={index}
                  className="searchResults--result"
                >
                  {result.coverImage?.fields?.file?.details && (
                    <Image
                      src={result.coverImage}
                      alt={result.coverImage.fields.title as string}
                      // width={
                      //   (result as any).coverImage.fields.file?.details.image
                      //     .width
                      // }
                      // height={
                      //   (result as any).coverImage.fields.file?.details.image
                      //     .height
                      // }
                      className="searchResults--result-image"
                      options={{
                        sizes: {
                          exec: [
                            {
                              width: 72,
                            },
                            {
                              width: 144,
                            },
                          ],
                        },
                      }}
                    />
                  )}
                  <div className="searchResults--result-info">
                    <div className="searchResults--result-group">
                      {result.group}
                    </div>
                    <div className="searchResults--result-date">
                      {formatDate(result.date)}
                    </div>
                    <div className="searchResults--result-title">
                      {result.title}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </>
      ) : (
        <div>{translations.empty}</div>
      )}
      {translations.cta.link?.uri && (results?.length || 0) > 0 && (
        <Link
          href={`${translations.cta.link.uri}?s=${searchValue}`}
          fill="full"
          theme="blue"
          title={`${translations.cta.text} (${resultsCount})`}
        >
          <span>
            {translations.cta.text} ({resultsCount})
          </span>
        </Link>
      )}
    </div>
  );
};
